export default {
  PENDING: '@MYYOLA/DIALOG_TYPES/PENDING',
  DOMAIN_SEARCH_FAILURE: '@MYYOLA/DIALOG_TYPES/DOMAIN_SEARCH_FAILURE',
  DELETE_SITE: '@MYYOLA/DIALOG_TYPES/DELETE_SITE',
  ERROR: '@MYYOLA/DIALOG_TYPES/ERROR',
  DELETE_ACCOUNT: '@MYYOLA/DIALOG_TYPES/DELETE_ACCOUNT',
  CHANGE_PASSWORD: '@MYYOLA/DIALOG_TYPES/CHANGE_PASSWORD',
  PAYMENT_METHOD_FORM: '@MYYOLA/DIALOG_TYPES/PAYMENT_METHOD_FORM',
  SUBSCRIPTION_EXPIRED: '@MYYOLA/DIALOG_TYPES/SUBSCRIPTION_EXPIRED',
  DELETE_PAYMENT_METHOD: '@MYYOLA/DIALOG_TYPES/DELETE_PAYMENT_METHOD',
  DELETE_DEFAULT_PAYMENT_METHOD: '@MYYOLA/DIALOG_TYPES/DELETE_DEFAULT_PAYMENT_METHOD',
  SET_DEFAULT_PAYMENT_METHOD: '@MYYOLA/DIALOG_TYPES/SET_DEFAULT_PAYMENT_METHOD',
  CANCEL_PLAN: '@MYYOLA/DIALOG_TYPES/CANCEL_PLAN',
  TERMS_OF_USE_DIALOG: '@MYYOLA/DIALOG_TYPES/TERMS_OF_USE_DIALOG',
  STRIPE_LOADING_ERROR: '@MYYOLA/DIALOG_TYPES/STRIPE_LOADING_ERROR',
  RESET_SITE: '@MYYOLA/DIALOG_TYPES/RESET_SITE',
  RESET_SITE_UNPUBLISH_CONFIRM: '@MYYOLA/DIALOG_TYPES/RESET_SITE_UNPUBLISH_CONFIRM',
  UNPUBLISH_SITE: '@MYYOLA/DIALOG_TYPES/UNPUBLISH_SITE',
  EXPORT_INFORMATION_DIALOG: '@MYYOLA/DIALOG_TYPES/EXPORT_INFORMATION_DIALOG',
  LEGACY_SITE_ERROR_DIALOG: '@MYYOLA/DIALOG_TYPES/LEGACY_SITE_ERROR_DIALOG',
  DIFM_UPSELL_DIALOG: '@MYYOLA/DIALOG_TYPES/DIFM_UPSELL_DIALOG',
  DIFM_ORDER_FORM_DIALOG: '@MYYOLA/DIALOG_TYPES/DIFM_ORDER_FORM_DIALOG',
  DIFM_ERROR_DIALOG: '@MYYOLA/DIALOG_TYPES/DIFM_ERROR_DIALOG',
};
